import { compositions as e } from "./schema-composition.js";
import { resolve as t } from "@scalar/workspace-store/resolve";
//#region src/schema/helpers/optimize-value-for-display.ts
function n(...e) {
	let t = {}, n = {}, r = /* @__PURE__ */ new Set(), i = !1, a = !1;
	for (let o of e) if (o) for (let [e, s] of Object.entries(o)) {
		if (e === "properties" && s && typeof s == "object") {
			Object.assign(n, s), i = !0;
			continue;
		}
		if (e === "required" && Array.isArray(s)) {
			for (let e of s) r.add(e);
			a = !0;
			continue;
		}
		t[e] = s;
	}
	return i && (t.properties = n), a && (t.required = [...r]), t;
}
function r(r) {
	if (!r || typeof r != "object") return r;
	let i = e.find((e) => e in r && e !== "not");
	if (!i) return { ...r };
	let a = r[i];
	if (!Array.isArray(a)) return { ...r };
	let { [i]: o, nullable: s, ...c } = r, l = Object.keys(c).length > 0, { filteredSchemas: u, hasNullSchema: d } = a.reduce((e, n) => {
		let r = t.schema(n);
		return "type" in r && r.type === "null" ? e.hasNullSchema = !0 : e.filteredSchemas.push(r), e;
	}, {
		filteredSchemas: [],
		hasNullSchema: !1
	}), f = d || s === !0;
	if (u.length === 1) {
		let e = n(u[0], c);
		return f && (e.nullable = !0), e;
	}
	if ((i === "oneOf" || i === "anyOf") && (l || u.some((e) => e.allOf))) {
		let { discriminator: e, ...a } = c, o = u.map((e) => {
			let r = t.schema(e);
			if (r.allOf?.length === 1) {
				let { allOf: e, ...i } = r, o = t.schema(e[0]);
				if ("properties" in i || "required" in i || "$ref" in i) {
					let { $ref: e, title: t, name: r, ...s } = o;
					return n(a, i, s);
				}
				return n(a, i, o);
			}
			return n(a, r);
		}), s = { [i]: o };
		return typeof r.description == "string" && (s.description = r.description), f && (s.nullable = !0), s;
	}
	if (u.length !== a.length) {
		let e = {
			...r,
			[i]: u
		};
		return f && (e.nullable = !0), e;
	}
	return { ...r };
}
//#endregion
export { r as optimizeValueForDisplay };

//# sourceMappingURL=optimize-value-for-display.js.map